import React from "react";
import NavClose from "./components/NavClose";
import NavDrawer from "./components/NavDrawer";

export default function NavResponsive({ drawerOpen, toggleDrawer }) {
  return (
    <>
      {drawerOpen && (
        <div className="fixed inset-0 bg-white z-50 p-5 lg:hidden w-screen h-screen">
          <NavClose toggleDrawer={toggleDrawer} />
          <NavDrawer toggleDrawer={toggleDrawer} />
        </div>
      )}
    </>
  );
}
